module.exports = __webpack_public_path__ + "close.cc5b2908.png";